module.exports = __webpack_public_path__ + "img/rspca-qld.3243722.png";